import { createContext } from "react";

const AnalyticsContext = createContext(null);

export default AnalyticsContext;
